import { createContext, useContext } from 'react';

import type { QueryState } from './types';

export type InstantSearchContextValue = {
  queryState: QueryState;
  updateQueryState: (newQueryState: Partial<QueryState>) => void;
};

export const InstantSearchContext = createContext<InstantSearchContextValue | undefined>(undefined);

export const useInstantSearchState = () => {
  const context = useContext(InstantSearchContext);
  if (!context) {
    throw new Error('useInstantSearchState must be used with an InstantSearch provider');
  }
  return context;
};
